export const selectWhatsappState = (state) => state.whatsapp;
export const selectWhatsappUserList = (state) => state.whatsapp.userList;
export const selectWhatsappSelectedContact = (state) => state.whatsapp.selectedContact;
export const selectWhatsappMessages = (state) => state.whatsapp;
